module.exports = __webpack_public_path__ + "img/media.beb5b6d1.png";